import { render, staticRenderFns } from "./novel-detail.vue?vue&type=template&id=f10ced96"
import script from "./novel-detail.vue?vue&type=script&lang=js"
export * from "./novel-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports